'use client';

import Link from '@eliadmin/core/src/components/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { MdOutlinePhoneInTalk } from 'react-icons/md';
import { BsEnvelopeCheck } from 'react-icons/bs';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';

export function ContactCards({ generalLayout }: { generalLayout: GeneralLayout['data'] }) {
  const { t } = useTranslations();

  return (
    <section className={cn('custom-section', 'py-8 sm:py-10 lg:py-12')}>
      <div
        className={cn(
          'custom-container--xxl',
          'grid grid-cols-1 gap-2 sm:grid-cols-2 md:gap-4 lg:gap-6',
        )}
      >
        <Link
          prefetch={false}
          href={`tel:${generalLayout?.contact?.phone}`}
          target="_blank"
          className="generic-hover col-span-1 flex w-full flex-col items-start justify-start gap-4 rounded-[20px] bg-secondary p-4 md:gap-6 md:p-6"
        >
          <div className="flex items-center justify-start gap-4 md:gap-6">
            <div className="flex h-12 w-12 items-center justify-center rounded-[12px] bg-primary/10">
              <MdOutlinePhoneInTalk size={24} className="text-primary" />
            </div>
            <Heading tag="h4" title={t('text3669')} className={{ title: 'text-primary' }} />
          </div>
          <div className="flex w-full flex-col items-start justify-start gap-2 md:gap-4">
            <Heading
              tag="h3"
              title={generalLayout?.contact?.phone ?? ''}
              className={{ title: 'text-primary' }}
            />
            <Paragraph className="text-primary" size="lg">
              {t('text3691')}
            </Paragraph>
          </div>
        </Link>
        <Link
          prefetch={false}
          href={`mailto:${generalLayout?.contact?.email}`}
          target="_blank"
          className="generic-hover col-span-1 flex w-full flex-col items-start justify-start gap-4 rounded-[20px] bg-secondary p-4 md:gap-6 md:p-6"
        >
          <div className="flex items-center justify-start gap-4 md:gap-6">
            <div className="flex h-12 w-12 items-center justify-center rounded-[12px] bg-primary/10">
              <BsEnvelopeCheck size={24} className="text-primary" />
            </div>
            <Heading tag="h4" title="E-mail" className={{ title: 'text-primary' }} />
          </div>
          <div className="flex w-full flex-col items-start justify-start gap-2 md:gap-4">
            <Heading
              tag="h3"
              title={generalLayout?.contact?.email ?? ''}
              className={{ title: 'text-primary' }}
            />
            <Paragraph className="text-primary" size="lg">
              {t('text569')}
            </Paragraph>
          </div>
        </Link>
      </div>
    </section>
  );
}
